import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

const schema = object({
  name: string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
  description: string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
  shortCode: string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
});

export const validate = makeValidate(schema);
